export default "__VITE_ASSET__VHyheUPL__"